// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ct9kVdatV78GHhK9QiJ54N
// Component: mb82fq-pYFy
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  hasVariant,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import SelectBusinessType from "../../SelectBusinessType"; // plasmic-import: 4omYklaUsMs/component
import SelectBusinessType__Option from "../../SelectBusinessType__Option"; // plasmic-import: ZzWMn50I_m-/component
import SelectBizClass from "../../SelectBizClass"; // plasmic-import: vWhk9cqiwZ0/component
import SelectBizClass__Option from "../../SelectBizClass__Option"; // plasmic-import: BmTOdnYKnWP/component
import { useScreenVariants as useScreenVariantsnoO6HAIuEe } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: NoO6H-AIuEE/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_astriusdraft.module.css"; // plasmic-import: ct9kVdatV78GHhK9QiJ54N/projectcss
import sty from "./PlasmicNewSetupDetails.module.css"; // plasmic-import: mb82fq-pYFy/css
import DividerLineVerticalIcon from "./icons/PlasmicIcon__DividerLineVertical"; // plasmic-import: Ql4i0eZ6cYO/icon

createPlasmicElementProxy;

export const PlasmicNewSetupDetails__VariantProps = new Array();

export const PlasmicNewSetupDetails__ArgProps = new Array("websiteorsocial");

const $$ = {};

function PlasmicNewSetupDetails__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "firstName.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "lastName.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "website.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "selectIndustry.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "selectBusinessType.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsnoO6HAIuEe()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <div className={classNames(projectcss.all, sty.freeBox__kM7Js)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__osVj3
              )}
            >
              {"Account Information"}
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__rvb7O)}>
            <div className={classNames(projectcss.all, sty.freeBox__m3Nl5)}>
              <div
                data-plasmic-name={"lineStack"}
                data-plasmic-override={overrides.lineStack}
                className={classNames(projectcss.all, sty.lineStack)}
              >
                <div
                  data-plasmic-name={"circle"}
                  data-plasmic-override={overrides.circle}
                  className={classNames(projectcss.all, sty.circle)}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg___1CKiw)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__w8Ufe)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle2"}
                  data-plasmic-override={overrides.circle2}
                  className={classNames(projectcss.all, sty.circle2)}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__bQfm9)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__aqEnd)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle3"}
                  data-plasmic-override={overrides.circle3}
                  className={classNames(projectcss.all, sty.circle3)}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__smJa)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__b9Yc)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle4"}
                  data-plasmic-override={overrides.circle4}
                  className={classNames(projectcss.all, sty.circle4)}
                />
              </div>
            </div>
            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__ksXLc)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__d4RmD
                )}
              >
                {"Account Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__yvTPs
                )}
              >
                {"Banking Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___2HXuI
                )}
              >
                {"Plan Information"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__hdwGc
                )}
              >
                {"Confirm Identity"}
              </div>
            </p.Stack>
            <div
              data-plasmic-name={"vertStack"}
              data-plasmic-override={overrides.vertStack}
              className={classNames(projectcss.all, sty.vertStack)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__fI9U)}>
                <div className={classNames(projectcss.all, sty.freeBox___4RPx)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__nDip
                    )}
                  >
                    {"First Name"}
                  </div>
                  <input
                    data-plasmic-name={"firstName"}
                    data-plasmic-override={overrides.firstName}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.firstName
                    )}
                    onChange={e => {
                      p.generateStateOnChangeProp($state, [
                        "firstName",
                        "value"
                      ])(e.target.value);
                    }}
                    placeholder={"First"}
                    ref={ref => {
                      $refs["firstName"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={
                      p.generateStateValueProp($state, [
                        "firstName",
                        "value"
                      ]) ?? ""
                    }
                  />
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__vn272)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__kZmKe
                    )}
                  >
                    {"Last Name"}
                  </div>
                  <input
                    data-plasmic-name={"lastName"}
                    data-plasmic-override={overrides.lastName}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.lastName
                    )}
                    onChange={e => {
                      p.generateStateOnChangeProp($state, [
                        "lastName",
                        "value"
                      ])(e.target.value);
                    }}
                    placeholder={"Last"}
                    ref={ref => {
                      $refs["lastName"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={
                      p.generateStateValueProp($state, ["lastName", "value"]) ??
                      ""
                    }
                  />
                </div>
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__wMs1G
                )}
              >
                {"Type of Business"}
              </div>
              <SelectBusinessType
                data-plasmic-name={"selectBusinessType"}
                data-plasmic-override={overrides.selectBusinessType}
                className={classNames("__wab_instance", sty.selectBusinessType)}
                onChange={(...eventArgs) => {
                  p.generateStateOnChangeProp($state, [
                    "selectBusinessType",
                    "value"
                  ])(eventArgs[0]);
                }}
                value={p.generateStateValueProp($state, [
                  "selectBusinessType",
                  "value"
                ])}
              >
                <SelectBusinessType__Option
                  className={classNames("__wab_instance", sty.option__uoHm)}
                  value={"individual"}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text___9B2Sj
                    )}
                  >
                    {"Individual"}
                  </div>
                </SelectBusinessType__Option>
                <SelectBusinessType__Option
                  className={classNames("__wab_instance", sty.option__vunNy)}
                  value={"company"}
                >
                  {"Company"}
                </SelectBusinessType__Option>
              </SelectBusinessType>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__kIosH
                )}
              >
                {"Industry"}
              </div>
              <SelectBizClass
                data-plasmic-name={"selectIndustry"}
                data-plasmic-override={overrides.selectIndustry}
                className={classNames("__wab_instance", sty.selectIndustry)}
                onChange={(...eventArgs) => {
                  p.generateStateOnChangeProp($state, [
                    "selectIndustry",
                    "value"
                  ])(eventArgs[0]);
                }}
                value={p.generateStateValueProp($state, [
                  "selectIndustry",
                  "value"
                ])}
              >
                <SelectBizClass__Option
                  className={classNames("__wab_instance", sty.option__rBHqz)}
                  value={"9ed38146-7d6f-11e3-89d6-5404a6144203"}
                >
                  {"Marketing"}
                </SelectBizClass__Option>
                <SelectBizClass__Option
                  className={classNames("__wab_instance", sty.option__pqHmx)}
                  value={"9ed46b9e-7d6f-11e3-9fec-5404a6144203"}
                >
                  {"Graphic Design"}
                </SelectBizClass__Option>
                <SelectBizClass__Option
                  className={classNames("__wab_instance", sty.option__tS5P)}
                  textValue={""}
                  value={"9ed3a851-7d6f-11e3-92a4-5404a6144203"}
                >
                  {"Software"}
                </SelectBizClass__Option>
                <SelectBizClass__Option
                  className={classNames("__wab_instance", sty.option__fOfV)}
                  textValue={""}
                  value={"9ed3cf60-7d6f-11e3-a80d-5404a6144203"}
                >
                  {"Accounting"}
                </SelectBizClass__Option>
                <SelectBizClass__Option
                  className={classNames("__wab_instance", sty.option__wsds1)}
                  value={"9ed3814f-7d6f-11e3-aaf6-5404a6144203"}
                >
                  {"Wholesale"}
                </SelectBizClass__Option>
                <SelectBizClass__Option
                  className={classNames("__wab_instance", sty.option__lvjaF)}
                  value={"9ed3813d-7d6f-11e3-bd65-5404a6144203"}
                >
                  {"Education"}
                </SelectBizClass__Option>
                <SelectBizClass__Option
                  className={classNames("__wab_instance", sty.option___1KisR)}
                  value={"9ed3813c-7d6f-11e3-82cc-5404a6144203"}
                >
                  {"Consulting"}
                </SelectBizClass__Option>
                <SelectBizClass__Option
                  className={classNames("__wab_instance", sty.option__ht2C)}
                  value={"9ed3cf63-7d6f-11e3-b50c-5404a6144203"}
                >
                  {"Investment Service"}
                </SelectBizClass__Option>
                <SelectBizClass__Option
                  className={classNames("__wab_instance", sty.option__bLncd)}
                  value={"9ed46b95-7d6f-11e3-970b-5404a6144203"}
                >
                  {"eCommerce Service"}
                </SelectBizClass__Option>
                <SelectBizClass__Option
                  className={classNames("__wab_instance", sty.option___0Dvk)}
                  value={"9ed3a853-7d6f-11e3-a35d-5404a6144203"}
                >
                  {"Web Hosting and Design"}
                </SelectBizClass__Option>
                <SelectBizClass__Option
                  className={classNames("__wab_instance", sty.option__p1Wa)}
                  value={"9ed4449a-7d6f-11e3-a380-5404a6144203"}
                >
                  {"Retailer"}
                </SelectBizClass__Option>
                <SelectBizClass__Option
                  className={classNames("__wab_instance", sty.option__neorY)}
                  value={"9ed41d7a-7d6f-11e3-ae21-5404a6144203"}
                >
                  {"Construction"}
                </SelectBizClass__Option>
                <SelectBizClass__Option
                  className={classNames("__wab_instance", sty.option__pMEia)}
                  value={"9ed46ba6-7d6f-11e3-ae95-5404a6144203"}
                >
                  {"Legal Services"}
                </SelectBizClass__Option>
                <SelectBizClass__Option
                  className={classNames("__wab_instance", sty.option__xj1Bh)}
                  value={"9ed35a38-7d6f-11e3-a24f-5404a6144203"}
                >
                  {"Publishing"}
                </SelectBizClass__Option>
                <SelectBizClass__Option
                  className={classNames("__wab_instance", sty.option__wcgng)}
                  value={"9ed444a6-7d6f-11e3-ad1c-5404a6144203"}
                >
                  {"Photography"}
                </SelectBizClass__Option>
                <SelectBizClass__Option
                  className={classNames("__wab_instance", sty.option__gLv6)}
                  value={"9ed492a5-7d6f-11e3-8d8f-5404a6144203"}
                >
                  {"Telecommunication Services"}
                </SelectBizClass__Option>
                <SelectBizClass__Option
                  className={classNames("__wab_instance", sty.option__ckgEg)}
                  value={"9ed4449f-7d6f-11e3-b867-5404a6144203"}
                >
                  {"Public Relations"}
                </SelectBizClass__Option>
                <SelectBizClass__Option
                  className={classNames("__wab_instance", sty.option__hdOl)}
                  value={"9ed46ba3-7d6f-11e3-9efe-5404a6144203"}
                >
                  {"Insurance"}
                </SelectBizClass__Option>
                <SelectBizClass__Option
                  className={classNames("__wab_instance", sty.option__wWizM)}
                  value={"9ed492ab-7d6f-11e3-9907-5404a6144203"}
                >
                  {"Real Estate"}
                </SelectBizClass__Option>
                <SelectBizClass__Option
                  className={classNames("__wab_instance", sty.option__sf98F)}
                  value={"9ed3814e-7d6f-11e3-9087-5404a6144203"}
                >
                  {"Secretarial Support"}
                </SelectBizClass__Option>
                <SelectBizClass__Option
                  className={classNames("__wab_instance", sty.option__sSevg)}
                  value={"9ed46b9a-7d6f-11e3-a11b-5404a6144203"}
                >
                  {"Event Planning Support"}
                </SelectBizClass__Option>
                <SelectBizClass__Option
                  className={classNames("__wab_instance", sty.option__mNQrV)}
                  value={"9ed4b9bb-7d6f-11e3-af9f-5404a6144203"}
                >
                  {"Travel Agency"}
                </SelectBizClass__Option>
                <SelectBizClass__Option
                  className={classNames("__wab_instance", sty.option___89Tl3)}
                  value={"9ed3f679-7d6f-11e3-a884-5404a6144203"}
                >
                  {"Gifting"}
                </SelectBizClass__Option>
                <SelectBizClass__Option
                  className={classNames("__wab_instance", sty.option__ggp88)}
                  value={"9ed38143-7d6f-11e3-bc00-5404a6144203"}
                >
                  {"Recruiting Services"}
                </SelectBizClass__Option>
                <SelectBizClass__Option
                  className={classNames("__wab_instance", sty.option___95O3)}
                  value={"9ed3cf5a-7d6f-11e3-9a99-5404a6144203"}
                >
                  {"Digital Media"}
                </SelectBizClass__Option>
              </SelectBizClass>
              <div className={classNames(projectcss.all, sty.freeBox___5UVj)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__eNjNx
                  )}
                >
                  {"Monthly Processing Volume"}
                </div>
                <div
                  data-plasmic-name={"monthlyVolume"}
                  data-plasmic-override={overrides.monthlyVolume}
                  className={classNames(projectcss.all, sty.monthlyVolume)}
                />

                <div className={classNames(projectcss.all, sty.freeBox__iMtLc)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__ndIlb
                    )}
                  >
                    {"Average Transaction Size"}
                  </div>
                  <div
                    data-plasmic-name={"averageTicket"}
                    data-plasmic-override={overrides.averageTicket}
                    className={classNames(projectcss.all, sty.averageTicket)}
                  />
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__z7GU)}>
                <div className={classNames(projectcss.all, sty.freeBox__qEfU)}>
                  {p.renderPlasmicSlot({
                    defaultContents: "Website or Social Media Profile Link",
                    value: args.websiteorsocial,
                    className: classNames(sty.slotTargetWebsiteorsocial)
                  })}
                </div>
                <input
                  data-plasmic-name={"website"}
                  data-plasmic-override={overrides.website}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.website
                  )}
                  onChange={e => {
                    p.generateStateOnChangeProp($state, ["website", "value"])(
                      e.target.value
                    );
                  }}
                  placeholder={""}
                  ref={ref => {
                    $refs["website"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={
                    p.generateStateValueProp($state, ["website", "value"]) ?? ""
                  }
                />
              </div>
              <div
                data-plasmic-name={"errorText"}
                data-plasmic-override={overrides.errorText}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.errorText
                )}
              >
                {hasVariant(globalVariants, "screen", "small") ? (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Must complete all required fields"}
                    </span>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Must complete all required fields"}
                    </span>
                  </React.Fragment>
                )}
              </div>
              <div
                data-plasmic-name={"continueButton"}
                data-plasmic-override={overrides.continueButton}
                className={classNames(projectcss.all, sty.continueButton)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__q2CKq
                  )}
                >
                  {"Continue"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "lineStack",
    "circle",
    "circle2",
    "circle3",
    "circle4",
    "vertStack",
    "firstName",
    "lastName",
    "selectBusinessType",
    "selectIndustry",
    "monthlyVolume",
    "averageTicket",
    "website",
    "errorText",
    "continueButton"
  ],

  lineStack: ["lineStack", "circle", "circle2", "circle3", "circle4"],
  circle: ["circle"],
  circle2: ["circle2"],
  circle3: ["circle3"],
  circle4: ["circle4"],
  vertStack: [
    "vertStack",
    "firstName",
    "lastName",
    "selectBusinessType",
    "selectIndustry",
    "monthlyVolume",
    "averageTicket",
    "website",
    "errorText",
    "continueButton"
  ],

  firstName: ["firstName"],
  lastName: ["lastName"],
  selectBusinessType: ["selectBusinessType"],
  selectIndustry: ["selectIndustry"],
  monthlyVolume: ["monthlyVolume"],
  averageTicket: ["averageTicket"],
  website: ["website"],
  errorText: ["errorText"],
  continueButton: ["continueButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicNewSetupDetails__ArgProps,
          internalVariantPropNames: PlasmicNewSetupDetails__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicNewSetupDetails__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicNewSetupDetails";
  } else {
    func.displayName = `PlasmicNewSetupDetails.${nodeName}`;
  }
  return func;
}

export const PlasmicNewSetupDetails = Object.assign(
  // Top-level PlasmicNewSetupDetails renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    lineStack: makeNodeComponent("lineStack"),
    circle: makeNodeComponent("circle"),
    circle2: makeNodeComponent("circle2"),
    circle3: makeNodeComponent("circle3"),
    circle4: makeNodeComponent("circle4"),
    vertStack: makeNodeComponent("vertStack"),
    firstName: makeNodeComponent("firstName"),
    lastName: makeNodeComponent("lastName"),
    selectBusinessType: makeNodeComponent("selectBusinessType"),
    selectIndustry: makeNodeComponent("selectIndustry"),
    monthlyVolume: makeNodeComponent("monthlyVolume"),
    averageTicket: makeNodeComponent("averageTicket"),
    website: makeNodeComponent("website"),
    errorText: makeNodeComponent("errorText"),
    continueButton: makeNodeComponent("continueButton"),
    // Metadata about props expected for PlasmicNewSetupDetails
    internalVariantProps: PlasmicNewSetupDetails__VariantProps,
    internalArgProps: PlasmicNewSetupDetails__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicNewSetupDetails;
/* prettier-ignore-end */
